export default "__VITE_ASSET__065b610e__"